import { useState, useCallback } from 'react';

export interface User {
    id: number;
    username: string;
    email: string;
    created_at: string;
    last_login: string;
    avatar_url: string;
    bio: string;
}

interface UseGetUserResult {
    getUser: (userId: number) => Promise<User | null>;
    isLoading: boolean;
    error: string | null;
    data: User | null;
}

const useGetUser = (): UseGetUserResult => {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);
    const [data, setData] = useState<User | null>(null);

    const getUser = useCallback(async (userId: number) => {
        setIsLoading(true);
        setError(null);

        try {
            const apiUrl = process.env.REACT_APP_API_BASE || '/api';
            const response = await fetch(`${apiUrl}/user/${userId}`, {
                method: 'GET',
            });

            if (!response.ok) {
                const errorText = await response.text();
                throw new Error(`HTTP error! status: ${response.status}, message: ${errorText}`);
            }

            const result = await response.json();
            setData(result);
            return result;
        } catch (err) {
            const errorMessage = err instanceof Error ? err.message : 'Неизвестная ошибка';
            setError(errorMessage);
            throw err;
        } finally {
            setIsLoading(false);
        }
    }, []);

    return { getUser, isLoading, error, data };
};

export default useGetUser;